import * as closeProjectOfficerType from './closeProjectOfficerType'
import useCloseProjectOfficer from './useCloseProjectOfficer'
import Button from '../../../../../control/button/button'
import MyTextfield from '../../../../../control/textfield/textfield'
import useTranslate from '../../../../../i18n/useTranslate'
import { Grid, useMediaQuery, useTheme } from '@material-ui/core'
import { Form } from 'react-final-form'
import React from 'react'

//View
const CloseProjectOfficerFormView = (props: closeProjectOfficerType.CloseProjectOfficerFormViewType) => {
    const { onClickSave, onClickClose } = props
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Form onSubmit={onClickSave} initialValues={{}} keepDirtyOnReinitialize={true}>
            {(props) => {
                const { handleSubmit } = props
                return (
                    <React.Fragment>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyTextfield
                                    name="remark"
                                    materialInputProps={{
                                        label: '',
                                        placeholder: translate.get('LABEL.REMARK'),
                                        size: 'small',
                                        rows: 5,
                                        multiline: true,
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={3} lg={3}>
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    fullWidth={isMobileView ? true : false}
                                    onClick={onClickClose}
                                    style={{ backgroundColor: '#FFFFFF', border: 'solid 1px #db5f8e' }}
                                >
                                    {translate.get('BUTTON.CANCEL')}
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth={isMobileView ? true : false}
                                    onClick={handleSubmit}
                                >
                                    {translate.get('BUTTON.SAVE')}
                                </Button>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const CloseProjectOfficerForm = (props: closeProjectOfficerType.CloseProjectOfficerFormType) => {
    const closeProjectOfficerFormModel = useCloseProjectOfficer(props)
    return <CloseProjectOfficerFormView {...closeProjectOfficerFormModel} {...props} />
}
export default CloseProjectOfficerForm
